import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public data :any) { }

  get logoutText(): string {
    const lang = localStorage.getItem('lang') || 'en-US';
    const dict: Record<string, string> = {
      'en-US': 'Logout',
      'hi-IN': 'लॉगआउट',
      'mr-IN': 'लॉगआउट',
      'bn-IN': 'লগআউট'
    };
    return dict[lang] || 'Logout';
  }

  get cancelText(): string {
    const lang = localStorage.getItem('lang') || 'en-US';
    const dict: Record<string, string> = {
      'en-US': 'Cancel',
      'hi-IN': 'कैंसल',
      'mr-IN': 'कॅन्सल',
      'bn-IN': 'ক্যান্সেল'
    };
    return dict[lang] || 'Cancel';
  }

  ngOnInit(): void {
    console.log("logout user id ", this.data);
  }
}
